import CustomTableRow from './CustomTableRow'

const renderTableRows = (items, handlers, state, level = 0) => {
  const {
    customLabels,
    handleCustomLabelChange,
    handleResetLabel,
    expandedRows,
    setExpandedRows,
    editingRowId,
    setEditingRowId,
    error,
    errorRowId
  } = handlers

  return items.flatMap((item) => {
    const rowId = item.id || item.name
    const hasChildren = item.children && item.children.length > 0
    const open = item.isTitle ? true : !!expandedRows[rowId]
    const toggleOpen = (e) => {
      if (hasChildren) {
        e.stopPropagation()
        setExpandedRows((prev) => ({...prev, [rowId]: !open}))
      }
    }
    const rows = [
      <CustomTableRow
        key={rowId}
        item={item}
        level={level}
        customLabels={customLabels}
        handleCustomLabelChange={handleCustomLabelChange}
        handleResetLabel={handleResetLabel}
        hasChildren={hasChildren}
        open={open}
        toggleOpen={toggleOpen}
        isEditing={editingRowId === rowId}
        setEditingRowId={setEditingRowId}
        rowId={rowId}
        disableEdit={Boolean(error && errorRowId && errorRowId !== rowId)}
        disableReset={Boolean(error && errorRowId && errorRowId !== rowId)}
        error={error}
        errorRowId={errorRowId}
      />
    ]
    if (hasChildren && open) {
      const childRows = renderTableRows(item.children, handlers, state, level + 1)
      rows.push(...childRows)
    }
    return rows
  })
}

export default renderTableRows
